<div class="content-card p-6">
  <h3 class="text-lg font-semibold text-gray-900 mb-4">
    {{ isEditMode ? 'Editar Questão' : 'Nova Questão' }}
  </h3>

  <form [formGroup]="questionForm" (ngSubmit)="onSave()" class="space-y-4">
    <div>
      <label
        for="question-text"
        class="mb-1 block text-sm font-medium text-gray-700"
      >
        Texto da Questão *
      </label>
      <textarea
        id="question-text"
        formControlName="text"
        rows="3"
        class="form-field-textarea placeholder-gray-500"
        [class.border-red-500]="isFieldInvalid('text')"
        placeholder="Digite o texto da questão"
      ></textarea>
      @if (isFieldInvalid('text')) {
      <p class="mt-1 text-sm text-red-600">{{ getFieldError('text') }}</p>
      }
    </div>

    <div class="grid grid-cols-2 gap-4">
      <div>
        <label
          for="question-type"
          class="mb-1 block text-sm font-medium text-gray-700"
        >
          Tipo de Questão *
        </label>
        <select
          id="question-type"
          formControlName="type"
          class="form-field-control"
        >
          @for (type of questionTypes; track type.value) {
          <option [value]="type.value">{{ type.label }}</option>
          }
        </select>
      </div>

      <div>
        <label
          for="question-points"
          class="mb-1 block text-sm font-medium text-gray-700"
        >
          Pontos *
        </label>
        <input
          type="number"
          id="question-points"
          formControlName="points"
          min="1"
          class="form-field-control"
          [class.border-red-500]="isFieldInvalid('points')"
        />
        @if (isFieldInvalid('points')) {
        <p class="mt-1 text-sm text-red-600">{{ getFieldError('points') }}</p>
        }
      </div>
    </div>

    <div>
      <div class="mb-2 block text-sm font-medium text-gray-700">
        Opções de Resposta *
      </div>
      <div formArrayName="options" class="space-y-2">
        @for (option of optionsFormArray.controls; track $index; let i = $index)
        {
        <div
          [formGroupName]="i"
          class="flex items-center gap-3 rounded border border-gray-300 px-3 py-1.5 transition-colors"
          [ngClass]="{
            'bg-white': !isCorrectAnswer(i),
            'bg-gray-100': isCorrectAnswer(i)
          }"
        >
          <span class="min-w-[15px] text-sm font-medium text-gray-700">
            {{ formatOptionLabel(option.get('label')?.value) }}
          </span>

          <input
            type="text"
            formControlName="text"
            class="flex-1 border-none bg-transparent px-3 py-2 text-sm text-gray-900 focus:outline-none placeholder:text-gray-400"
            placeholder="Digite o texto da opção"
          />

          @if (optionsFormArray.length > 2) {
          <button
            type="button"
            class="rounded p-2 text-red-600 transition-colors hover:bg-red-50"
            (click)="removeOption(i)"
            title="Remover opção"
          >
            <i class="bi bi-trash text-sm"></i>
          </button>
          }

          <button
            type="button"
            class="rounded p-2 transition-colors"
            [class.text-[var(--color-primary)]]="isCorrectAnswer(i)"
            [class.text-gray-400]="!isCorrectAnswer(i)"
            (click)="toggleCorrectAnswer(i)"
            [title]="isCorrectAnswer(i) ? 'Resposta correta' : 'Marcar como correta'"
          >
            <i
              class="bi text-lg"
              [ngClass]="isCorrectAnswer(i) ? 'bi-check-circle-fill' : 'bi-circle'"
            ></i>
          </button>
        </div>
        }
      </div>
      @if (questionForm.get('type')?.value !== 'boolean') {
      <button
        type="button"
        class="mt-2 rounded px-3 py-1.5 text-sm text-[var(--color-primary)] hover:bg-[var(--color-primary-soft)]"
        (click)="addOption(getNextOptionLabel(), '')"
      >
        <i class="bi bi-plus-circle mr-1"></i>
        Adicionar Opção
      </button>
      }
    </div>

    <div
      class="form-actions flex items-center justify-end gap-3 border-t border-gray-200 pt-4"
    >
      <button type="button" class="btn-secondary" (click)="onCancel()">
        Cancelar
      </button>
      <button
        type="submit"
        class="btn-primary"
        [disabled]="questionForm.invalid"
      >
        {{ isEditMode ? 'Salvar Alterações' : 'Adicionar Questão' }}
      </button>
    </div>
  </form>
</div>
